/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ngx-toastr';
import * as i2 from '@angular/common';
export const ToastContainerModuleNgFactory:i0.NgModuleFactory<i1.ToastContainerModule> = i0.ɵcmf(i1.ToastContainerModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,([] as any[])],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(512,
          i1.ToastContainerModule,i1.ToastContainerModule,([] as any[]))]);
    });
export const ToastrModuleNgFactory:i0.NgModuleFactory<i1.ToastrModule> = i0.ɵcmf(i1.ToastrModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[ToastNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(4608,
          i2.NgLocalization,i2.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(512,i2.CommonModule,
          i2.CommonModule,([] as any[])),i0.ɵmpd(512,i1.ToastrModule,i1.ToastrModule,
          [[3,i1.ToastrModule]])]);
    });
const styles_Toast:any[] = ([] as any[]);
export const RenderType_Toast:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_Toast,
    data:{'animation':[{type:7,name:'flyInOut',definitions:[{type:0,name:'inactive',
        styles:{type:6,styles:{display:'none',opacity:0},offset:(null as any)},options:(undefined as any)},
        {type:0,name:'active',styles:{type:6,styles:{opacity:1},offset:(null as any)},
            options:(undefined as any)},{type:0,name:'removed',styles:{type:6,styles:{opacity:0},
            offset:(null as any)},options:(undefined as any)},{type:1,expr:'inactive => active',
            animation:{type:4,styles:(null as any),timings:'300ms ease-in'},options:(null as any)},
        {type:1,expr:'active => removed',animation:{type:4,styles:(null as any),timings:'300ms ease-in'},
            options:(null as any)}],options:{}}]}});
function View_Toast_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'button',[['class',
      'toast-close-button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.remove()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n    ×\n  ']))],
      (null as any),(null as any));
}
function View_Toast_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',([] as any[]),
      [[8,'className',0],[1,'aria-label',0]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(1,(null as any),['\n    ','\n  ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = i0.ɵinlineInterpolate(1,'',_co.options.titleClass,'');
        const currVal_1:any = _co.title;
        _ck(_v,0,0,currVal_0,currVal_1);
        const currVal_2:any = _co.title;
        _ck(_v,1,0,currVal_2);
      });
}
function View_Toast_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',([] as any[]),
      [[8,'className',0],[8,'innerHTML',1]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'',_co.options.messageClass,'');
    const currVal_1:any = _co.message;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
function View_Toast_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',([] as any[]),
      [[8,'className',0],[1,'aria-label',0]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(1,(null as any),['\n    ','\n  ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = i0.ɵinlineInterpolate(1,'',_co.options.messageClass,
            '');
        const currVal_1:any = _co.message;
        _ck(_v,0,0,currVal_0,currVal_1);
        const currVal_2:any = _co.message;
        _ck(_v,1,0,currVal_2);
      });
}
function View_Toast_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),
      0,'div',[['class','toast-progress']],[[4,'width','%']],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.width;
        _ck(_v,2,0,currVal_0);
      });
}
export function View_Toast_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_Toast_1)),i0.ɵdid(2,16384,(null as any),
      0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_Toast_2)),i0.ɵdid(5,16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_Toast_3)),i0.ɵdid(8,16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_Toast_4)),i0.ɵdid(11,16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_Toast_5)),i0.ɵdid(14,16384,(null as any),
          0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    var _co:i1.Toast = _v.component;
    const currVal_0:any = _co.options.closeButton;
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = _co.title;
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = (_co.message && _co.options.enableHtml);
    _ck(_v,8,0,currVal_2);
    const currVal_3:any = (_co.message && !_co.options.enableHtml);
    _ck(_v,11,0,currVal_3);
    const currVal_4:any = _co.options.progressBar;
    _ck(_v,14,0,currVal_4);
  },(null as any));
}
export function View_Toast_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',[['toast-component',
      '']],[[8,'className',0],[40,'@flyInOut',0]],[[(null as any),'click'],[(null as any),
      'mouseenter'],[(null as any),'mouseleave']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,1).tapToast()) !== false);
      ad = (pd_0 && ad);
    }
    if (('mouseenter' === en)) {
      const pd_1:any = ((<any>i0.ɵnov(_v,1).stickAround()) !== false);
      ad = (pd_1 && ad);
    }
    if (('mouseleave' === en)) {
      const pd_2:any = ((<any>i0.ɵnov(_v,1).delayedHideToast()) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },View_Toast_0,RenderType_Toast)),i0.ɵdid(1,180224,(null as any),0,i1.Toast,[i1.ToastrService,
      i1.ToastPackage,i0.ApplicationRef],(null as any),(null as any))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = i0.ɵnov(_v,1).toastClasses;
        const currVal_1:any = i0.ɵnov(_v,1).state;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
export const ToastNgFactory:i0.ComponentFactory<i1.Toast> = i0.ɵccf('[toast-component]',
    i1.Toast,View_Toast_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/$$_gendir/~/ngx-toastr/index.ngfactory.ts